import React from 'react';
import { Tooltip, Typography } from '@mui/material';

function GridTitle(props) {
    const { title, tooltip } = props;

    return (
        <Tooltip title={tooltip} placement="top" arrow>
            <Typography variant="body2" noWrap sx={{ fontSize: '11px' }}>
                {title}
            </Typography>
        </Tooltip>
    );
}

export default GridTitle;
